"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Grantee_1 = require("./_Grantee");
exports._Grant = {
    type: "structure",
    required: [],
    members: {
        Grantee: {
            shape: _Grantee_1._Grantee
        },
        Permission: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_Grant.js.map